<script>
	import Gallery from '../Stores/Gallery';
	import Helper from '../Classes/Helper';
	import Product from '../Stores/Product';

	export let resource;

	let canvas = {};
	let image_visible = true;
	let product_ready = false;
	let renderer_ready = false;
	let renderer_model = '';
	let renderer_loading = true;

	function reset() {
		product_ready = false;
		renderer_model = '';
		renderer_loading = true;
	}

	function loading(event) {
		renderer_loading = true;
	}

	async function ready(event) {
		const config = {
			resource,
			element: canvas,
			interaction: false
		};

		await window.renderer.init(config);
		renderer_ready = true; /* Leave in this order of calls. */
		window.renderer.autoRotation(false);
		await render();
	}

	async function render() {
		if (product_ready && renderer_ready) {
			image_visible = !$Product.render_model;
			if (!image_visible) {
				const config = {
					type: $Product.render_type,
					model: $Product.render_model,
					base: $Product.render_base
				};

				renderer_model = config.model;
				await window.renderer.load(config);
			}

			else {
				renderer_loading = false;
				Gallery.clear();
			}
		}
	}

	async function loaded(event) {
		const config = $Product.config.renderer;
		if (Helper.is(config))
			for (let texture in config)
				await window.renderer.texture(texture, config[texture]);

		await Gallery.render();
		renderer_loading = false;
	}

	Product.subscribe(async data => {
		if (Helper.is(data)) {
			const model = $Product.render_model;
			if (renderer_model !== model) {
				reset();
				renderer_model = model;
				product_ready = true;
				await render();
			}
		}
	});

	window.addEventListener('renderer_ready', ready, false);
	window.addEventListener('renderer_loading', loading, false);
	window.addEventListener('renderer_loaded', loaded, false);
</script>

<style>
	div.zes-media {
		flex-grow: 1;
		z-index: 10;
	}

	/* Renderer */

	div.zes-renderer {
		position: absolute;
		top: 0; right: 0; bottom: 0; left: 0;
	}

	div.zes-renderer-loading {
		opacity: 0;
	}

	/* Image */

	div.zes-image {
		position: absolute;
		top: 0; right: 0; bottom: 0; left: 0;
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
	}

	/* Spinner */

	div.zes-spinner {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100%;
	}

	div.zes-spinner-box {
		position: absolute;
		width: 10em;
		height: 10em;
	}

	circle {
		fill: transparent;
		stroke: hsl(0deg 100% 100% / .85);
		stroke-width: 5px;
		stroke-linecap: round;
		filter: url(#zes_spinner_shadow);

		transform-origin: center;
		animation-name: animation;
		animation-duration: 1.2s;
		animation-timing-function: ease-in-out;
		animation-iteration-count: infinite;
	}

	@keyframes animation {
		0% {
			stroke-dasharray: 1 98;
			stroke-dashoffset: -105;
		}

		50% {
			stroke-dasharray: 80 10;
			stroke-dashoffset: -160;
		}

		100% {
			stroke-dasharray: 1 98;
			stroke-dashoffset: -300;
		}
	}

	/* XR */

	:global(#VRButton) {
		visibility: hidden;
	}

	/* Responsive */

	@media only screen and (max-width: 1024px) and (orientation: portrait) {
		div.zes-media {
			font-size: .7em;
		}
	}
</style>

<div class="zes-media">
	{#if renderer_loading}
		<div class="zes-spinner">
			<div class="zes-spinner-box">
				<svg viewBox="0 0 100 100">
					<defs>
						<filter id="zes_spinner_shadow">
							<feDropShadow dx="0" dy="0" stdDeviation="2" flood-color="rgba(0, 0, 0, .25)"/>
						</filter>
					</defs>
					<circle cx="50" cy="50" r="45"/>
				</svg>
			</div>
		</div>
	{/if}
	<div bind:this="{canvas}" class="zes-renderer" class:zes-renderer-loading="{renderer_loading}"></div>
	{#if $Product.thumbnail && image_visible}
		<div class="zes-image" style="background-image: url({$Product.thumbnail});"></div>
	{/if}
</div>